import { getApiVersion, http } from '../utils/domain'

import { transformFields } from '../utils/transformers'

const prefix = (appId, tbId) => {
  return `${getApiVersion()}/apps/${appId}/tbs/${tbId}`
}

// 更新表名称、表定义
export const updateTable = (appId, tbId, params) => {
  // 万一 area 丢失的话。。。
  // params.tbNodes.push({
  //   nodeTemplateId: 0,
  //   readonly: false,
  //   remoteable: true,
  //   required: true,
  //   slug: 'area',
  //   title: '检查点位',
  //   type: 'area',
  // })
  return http().put(
    `${prefix(appId, tbId)}/def?updateTableName=${!!params.tbName}`,
    {
      ...params,
      tbNodes: transformFields(params.tbNodes),
    }
  )
}

// 删除解绑字段接口
export const destoryField = (appId, tbId, params) => {
  return http().put(
    `${prefix(
      appId,
      tbId
    )}/defAndUnbindStandard?updateTableName=${!!params.tbName}`,
    {
      ...params,
      tbNodes: transformFields(params.tbNodes),
    }
  )
}
